import React, { FC } from 'react';
import { SubHeader } from '../../../components/sub-header/SubHeader';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { LawyerActionSlider } from './LawyerActionSlider';

type Props = {
  isVisible: boolean;
};

export const LawyerSubHeader: FC<Props> = ({ isVisible }) => {
  return (
    <SubHeader classNames="hide_on--mobile" id="lawyer-sub-header">
      <SubHeaderRails>
        <LawyerActionSlider isVisible={isVisible} />
      </SubHeaderRails>
    </SubHeader>
  );
};
